/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityStatsResponse } from './MonitEntityStatsResponse';
import {
    MonitEntityStatsResponseFromJSON,
    MonitEntityStatsResponseFromJSONTyped,
    MonitEntityStatsResponseToJSON,
} from './MonitEntityStatsResponse';

/**
 * 
 * @export
 * @interface MonitEntityStatsLogResponse
 */
export interface MonitEntityStatsLogResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsLogResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsLogResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsLogResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityStatsResponse>}
     * @memberof MonitEntityStatsLogResponse
     */
    results?: Array<MonitEntityStatsResponse>;
}

/**
 * Check if a given object implements the MonitEntityStatsLogResponse interface.
 */
export function instanceOfMonitEntityStatsLogResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityStatsLogResponseFromJSON(json: any): MonitEntityStatsLogResponse {
    return MonitEntityStatsLogResponseFromJSONTyped(json, false);
}

export function MonitEntityStatsLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityStatsLogResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityStatsResponseFromJSON)),
    };
}

export function MonitEntityStatsLogResponseToJSON(value?: MonitEntityStatsLogResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityStatsResponseToJSON)),
    };
}

